'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cloneObject = require('./src/clone-object');

Object.defineProperty(exports, 'cloneObject', {
  enumerable: true,
  get: function get() {
    return _cloneObject.cloneObject;
  }
});

var _sortObject = require('./src/sort-object');

Object.defineProperty(exports, 'sortObject', {
  enumerable: true,
  get: function get() {
    return _sortObject.sortObject;
  }
});

var _syncObjectKeys = require('./src/sync-object-keys');

Object.defineProperty(exports, 'syncObjectKeys', {
  enumerable: true,
  get: function get() {
    return _syncObjectKeys.syncObjectKeys;
  }
});

var _deepGet = require('./src/deep-get');

Object.defineProperty(exports, 'deepGet', {
  enumerable: true,
  get: function get() {
    return _deepGet.deepGet;
  }
});

var _deepSet = require('./src/deep-set');

Object.defineProperty(exports, 'deepSet', {
  enumerable: true,
  get: function get() {
    return _deepSet.deepSet;
  }
});

var _deepDelete = require('./src/deep-delete');

Object.defineProperty(exports, 'deepDelete', {
  enumerable: true,
  get: function get() {
    return _deepDelete.deepDelete;
  }
});